import { useCallback, useMemo } from "react";

import { Form, Input, Select } from "antd";

import { RVFormFloatingLabelWrap, BADGE_STATUS, RVLink, RVFormItem, RVStatusSelectOption } from "@regal-voice/ui";
import { generateFormItemRequiredRules } from "Components/FormItems/Shared/Validators/InputValidators/InputValidators";
import { useOrchestrationPathing } from "Pages/orchestration/useOrchestrationPathing";

import { SendEmailFormItemKeys } from "../constants";

const DEMO_OPTIONS = [
    {
        name: "At Risk Email (ID# 12415)",
        state: "active",
        id: "1",
    },
];

const REQUIRED_RULE = generateFormItemRequiredRules("Email Campaign");
const ID_LABEL = "Campaign Name";
const LINK_TEXT = "Edit Campaign";

export function SendEmailFormItems(): JSX.Element {
    const form = Form.useFormInstance();
    const { campaignsBasePath } = useOrchestrationPathing();

    const aiOptions = useMemo(() => {
        return DEMO_OPTIONS?.map((demo) => {
            const { name, state } = demo;
            const badgeStatus = state === "draft" ? BADGE_STATUS.PENDING : BADGE_STATUS.ACTIVE;
            return {
                label: <RVStatusSelectOption name={name} badgeStatus={badgeStatus} badgeContent={state} />,
                value: demo.id,
            };
        });
    }, []);

    const handleSMSSelect = useCallback(
        (value: string) => {
            const fileName = DEMO_OPTIONS?.find((file) => file.id === value)?.name;
            form.setFieldValue(SendEmailFormItemKeys.sendEmailName, fileName);
        },
        [form]
    );

    return (
        <>
            <RVFormFloatingLabelWrap
                showFormLabel
                name={SendEmailFormItemKeys.sendEmailID}
                label={ID_LABEL}
                rules={REQUIRED_RULE}
            >
                <Select options={aiOptions} onChange={handleSMSSelect} />
            </RVFormFloatingLabelWrap>
            <RVFormItem name={SendEmailFormItemKeys.sendEmailName} hidden>
                <Input />
            </RVFormItem>

            <RVLink to={campaignsBasePath} text={LINK_TEXT} />
        </>
    );
}
